import Hero from "../components/Hero";
import SEO from "../components/SEO";

export default function Home() {
  return (
    <div>
      <SEO
        title="Sri Venkateswara Degree & PG College, Nellore | Home"
        description="Official website of Sri Venkateswara Degree & PG College, Nellore. Admissions, Academics, Facilities, Contact. Trusted since 1992 offering Intermediate, UG & PG programs."
      />
      <Hero />
      <section id="about" className="section section-muted">
        <div className="container text-center">
          <h2 className="text-3xl md:text-4xl font-semibold text-neutral-900">About the College</h2>
          <p className="mt-6 text-lg leading-relaxed text-neutral-700">
            Sri Venkateswara College has been a trusted name in Nellore for Undergraduate, and Postgraduate education. With a commitment to academic excellence, discipline, and value-based education, the institution has nurtured thousands of students who have excelled in professional careers, higher studies, and public service.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container grid md:grid-cols-2 gap-10 items-start">
          <div className="card p-6">
            <h3 className="text-2xl font-semibold text-neutral-900">Our Motto</h3>
            <p className="mt-3 text-neutral-700">Imparting Knowledge, Building Character, Serving Society</p>
            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
              <div className="p-4 rounded-lg bg-primary-50 text-primary-800">
                Established: <span className="font-semibold">1992</span>
              </div>
              <div className="p-4 rounded-lg bg-primary-50 text-primary-800">
                Founder & Director: <span className="font-semibold">Dr. Peddisetty Suneel Kumar, Ph.D.</span>
              </div>
              <div className="p-4 rounded-lg bg-primary-50 text-primary-800 sm:col-span-2">
                Affiliation: <span className="font-semibold">AICTE, Vikrama Simhapuri University (UG & PG)</span>
              </div>
            </div>
          </div>
          <div className="card p-6">
            <h3 className="text-2xl font-semibold text-neutral-900">Vision</h3>
            <p className="mt-3 text-neutral-700">To be a leading educational institution in Nellore, dedicated to imparting quality education that nurtures intellect, character, and social responsibility.</p>
            <h3 className="mt-6 text-2xl font-semibold text-neutral-900">Mission</h3>
            <ul className="mt-3 space-y-2 text-neutral-700 list-disc ml-5">
              <li>Foster holistic development, research, and innovation.</li>
              <li>Enhance employability and entrepreneurial skills.</li>
              <li>Instill values, ethics, and social responsibility.</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="section section-muted">
        <div className="container">
          <h3 className="text-2xl font-semibold text-neutral-900 text-center">Highlights</h3>
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              'Well-equipped laboratories and IT infrastructure',
              'Spacious library with latest books & e-resources',
              'Seminar Hall, sports facilities, and cultural activities',
              'Hostel accommodation and medical facilities',
              'Experienced and dedicated faculty members',
              'Career guidance and placement support for students',
            ].map((item) => (
              <div key={item} className="card p-5">
                <p className="text-neutral-700">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h3 className="text-2xl font-semibold text-neutral-900 text-center">Quick Links</h3>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <a href="/about" className="btn-outline">About Us</a>
            <a href="/academics" className="btn-outline">Courses Offered</a>
            <a href="/contact" className="btn-outline">Admissions</a>
            <a href="/facilities" className="btn-outline">Facilities &amp; PG Programs</a>
            <a href="/contact" className="btn-outline">Contact Us</a>
          </div>
        </div>
      </section>
    </div>
  );
}
